import Vue from 'vue';
import router from '@/router';
import axios from '@/axios';

const state = {
  firstPage: null,
  pages: [],
};
const actions = {
  fetchNavigation({commit}) {
    return axios.get('navigation')
      .then((r) => {
        commit('SET_FIRST_PAGE', r.data.firstPage)
        commit('SET_PAGES', r.data.navigation)
      });
  },
  clearPages({commit}) {
    commit('CLEAR_PAGES');
  },
  addPage({commit}, page) {
    commit('ADD_PAGE', page);
  },
  pushToFirstAvailablePage({commit}) {
    commit('PUSH_TO_FIRST_AVAILABLE_PAGE');
  },
  pushToFirstPage({commit}) {
    commit('PUSH_TO_FIRST_PAGE')
  },
};

const mutations = {
  ADD_PAGE(state, page) {
    state.pages.push(page);
  },
  CLEAR_PAGES(state) {
    state.pages = [];
  },
  PUSH_TO_FIRST_AVAILABLE_PAGE(state) {
    if (state.pages[0]) {
      router.push(state.pages[0].to);
    } else {
      router.push({name: 'ProfilePage'});
    }
  },
  SET_PAGES(state, pages) {
    Vue.set(state, 'pages', pages);
  },
  SET_FIRST_PAGE(state, firstPage) {
    Vue.set(state, 'firstPage', firstPage);
  },
  PUSH_TO_FIRST_PAGE(state) {
    router.push(state.firstPage || {name: 'ProfilePage'});
  },
};

const getters = {
  getMatchingRoute:
      state => (route) => state.pages.find(page => router.resolve(page.to).href === router.resolve(route).href)
}

export default {
  state,
  actions,
  mutations,
  getters,
}

